export default __webpack_public_path__ + "static/char-34-0f7cdbd91288482f3d0d161e68f705ac.gif";